import { FuseChipSelect } from "@fuse";
import _ from "@lodash";
import { FormControl, MenuItem, Paper, Tab, Tabs, TextField, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import TagFormulario from "app/Core/Components/TagFormulario/TagFormulario";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import EmpresaClienteApp from "app/ERP/EmpresaCliente/EmpresaClienteApp";
import EmpresaTarefaApp from "app/ERP/EmpresaTarefa/EmpresaTarefaApp";
import clsx from "clsx";
import MobileDetect from "mobile-detect";
import React from "react";
import { Anotacao, Contato, DataHora, Produto, Responsavel } from "../Components";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    },
    formControl: {
        margin: "0px 0",
        width: "100%",
        "&:last-child": {
            marginBottom: 0
        }
    },
    group: {},
    formGroupTitle: {
        position: "absolute",
        top: -10,
        left: 8,
        fontWeight: 600,
        padding: "0 4px",
        backgroundColor: theme.palette.type === "dark" ? "#424242" : "#FFF",
        fontSize: "12px",
    },
    formGroup: {
        position: "relative",
        maxHeight: "58px",
        border: "1px solid " + theme.palette.divider,
        borderRadius: 2,
    },
    spanlabel: {
        top: 9,
        left: 15,
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        paddingRight: 5,
        paddingLeft: 5,
        fontSize: 12.5,
        fontFamily: "Muli,Roboto,\"Helvetica\",Arial,sans-serif",
        color: theme.palette.text.secondary,
        maxWidth: 140,
    },
    divPaperHorario: {
        height: 400,
        maxWidth: "100%",
    },
    divContatos: {
        backgroundColor: theme.palette.background.paper,

    },
    selected: {
        backgroundColor: theme.palette.type === "dark" ? "rgb(255, 255, 255, .1)" : "rgb(0, 0, 0, .08)"
    },
    select: {
        "& .fuse-chip-select__indicators": {
            display: "none"
        },
        "& div:before, div:after": {
            "border-bottom": "none !important",
        },
    },
    toolbar: {
        background: theme.palette.type === "dark" ? "#303030" : "#E6E6E6",
        borderRadius: "4px 4px 0 0"
    },
});

const STATUS = [  // ALTERAR LABEL MAS NUNCA ALTERAR ID (EXISTEM FILTRO NO BANCO)
    { "id": 1, "label": "Agenda bloqueada", "icon": "block", "iniciarprocesso": false, "cancelarprocesso": false, "disabled": [5, 6, 7] },
    { "id": 5, "label": "Cancelado pelo profissional", "icon": "calendar_minus", "iniciarprocesso": false, "cancelarprocesso": false, "disabled": [5, 6, 7] },
    { "id": 6, "label": "Cancelado pelo cliente", "icon": "calendar_close", "iniciarprocesso": false, "cancelarprocesso": false, "disabled": [5, 6, 7] },
];

class Bloqueio extends XAPPComponent {

    state = {
        showContent: 0,
        filtroPessoa: "",
        showHorarios: false
    };

    componentDidUpdate() {
        if (!_.isNull(document.getElementById("ContentDivHorario")) && !_.isNull(document.getElementById("Content"))) {
            document.getElementById("ContentDivHorario").style.height = (document.getElementById("Content").parentNode.offsetHeight - 120 + "px");
        }
    }

    isMobileCliente = () => {
        const { form } = this.props;

        return ((!_.isNull(md.mobile()) || !_.isNull(md.tablet())) || (!_.isUndefined(form.clientesLookup) && !_.isNull(form.clientesLookup) && form.clientesLookup.length > 1));
    };

    getPessoaFiltro = () => {
        const { form } = this.props;
        let AResponse = [];
        if (this.state.filtroPessoa.length === 0) {
            return form.clientesLookup;
        }
        else {
            form.clientesLookup.forEach(item => {
                if (item.nome.toLowerCase().includes(this.state.filtroPessoa.toLowerCase())) {
                    AResponse.push(item);
                }
            });
        }
        return AResponse;
    };

    showSidebar = () => {
        const { form } = this.props;
        const { showContent } = this.state;
        return (showContent === 0 && (
            (!_.isNull(form.responsaveis) && form.responsaveis.length > 0)
            // || (!_.isUndefined(form.preatendimento.pedido) && !_.isNull(form.preatendimento.pedido) && form.preatendimento.pedido.length > 0)
        ));
    };

    getLabelPaper = (_AID) => {
        switch (_AID) {
            case 0: return "Bloqueio";
            case 1: return "Anotações";
            case 2: return "Tarefas";
            default: return "Agendamento";
        }
    };

    render() {
        const { callback, form, handleChange, handleLookupClientes, TagsPessoa, saveAgendamentoPessoa, TagsAgendamento, EmpresaLocais, get, user, getResponsaveis, handleChangeHorarios, checkHorarioDisponivel, handleResponsaveis, handleChangeAnotacoes, classes, xappRouteParams, HorarioAgendado, handleChangeData, save } = this.props;


        return (
            <React.Fragment>
                <Tabs
                    value={form.tabValue}
                    onChange={(ev, n) => handleChange({ target: { name: "tabValue", value: n } })}
                    indicatorColor="secondary"
                    textColor="secondary"
                    variant="scrollable"
                    scrollButtons="off"
                    classes={{ root: "h-48 w-full" }}
                >
                    <Tab value={0} className="h-48 normal-case" label={"Principal"} />
                    {this.isMobileCliente() &&
                        <Tab value={1} className="h-48 normal-case" label={"Clientes"} />
                    }
                    <Tab value={3} className="h-48 normal-case" label={"Responsáveis"} />
                </Tabs>
                {form.tabValue === 0 &&
                    <React.Fragment>
                        <div id="Content" className={"w-full flex px-8 lg:px-16 flex-wrap lg:flex-no-wrap lg:flex-row"}>
                            <div className={"flex w-full items-start flex-col"} >
                                {(!this.isMobileCliente()) && !_.isUndefined(form.clientesLookup) && !_.isNull(form.clientesLookup) && form.clientesLookup.length > 0 &&
                                    <div id="divContatos" className={clsx(classes.divContatos, "w-full", document.fullscreenElement && "p-12")} >
                                        {form.clientesLookup.length > 5 &&
                                            <div className="flex w-full items-center">
                                                <TextField
                                                    className="w-full"
                                                    id="filtroPessoa"
                                                    name="filtroPessoa"
                                                    value={this.state.filtroPessoa}
                                                    onChange={ev => this.setState(_.set({ ...this.state }, "filtroPessoa", ev.target.value))}
                                                    fullWidth
                                                    placeholder="Filtrar"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                                <XAPPButton
                                                    id="buttonFullScreen"
                                                    icon={!document.fullscreenElement ? "full_screen" : "exit_full_screen"}
                                                    type="icon"
                                                />
                                            </div>
                                        }
                                        <div className="flex flex-wrap w-full">
                                            {this.getPessoaFiltro().length > 0 ?
                                                <React.Fragment>
                                                    {this.getPessoaFiltro().map((item, x) => (
                                                        <Contato
                                                            key={x}
                                                            data={item}
                                                            xappRouteParams={xappRouteParams}
                                                            agendamento={form}
                                                            save={save}
                                                            saveAgendamentoPessoa={saveAgendamentoPessoa}
                                                            get={get}
                                                            STATUS={STATUS}
                                                            showTitle={true}
                                                            showChat={false}
                                                            showConfirmar={false}
                                                            showPedido={false}
                                                            TagsPessoa={TagsPessoa}
                                                            handleChange={handleChange}
                                                        />
                                                    ))}
                                                </React.Fragment>
                                                :
                                                <div className="flex w-full justify-center">
                                                    <Typography className={"text-13 mb-12 whitespace-no-wrap"}>{"O filtro não localizou resultados"}</Typography>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }

                                <Paper className={clsx(classes.divDados, "flex flex-col items-center w-full mt-8 pb-12")}>
                                    <div className={clsx(classes.toolbar, "w-full flex flex-row items-start justify-start items-center")}>
                                        <Typography className="ml-8" color="action">{this.getLabelPaper(this.state.showContent)}</Typography>
                                        <div className="flex-1" />
                                        <XAPPButton
                                            tooltip={{ "title": "Agendamento", "placement": "top" }}
                                            type="icon"
                                            className={clsx("p-8", this.state.showContent === 0 && classes.selected)}
                                            variant="contained"
                                            color="textSecondary"
                                            onClick={() => this.setState(_.set({ ...this.state }, "showContent", 0))}
                                            iconProps={clsx(classes.textColor, "text-18")}
                                            icon={"forms"}
                                        />
                                        <XAPPButton
                                            tooltip={{ "title": "Anotações", "placement": "top" }}
                                            type="icon"
                                            className={clsx("p-8", this.state.showContent === 1 && classes.selected)}
                                            variant="contained"
                                            color="textSecondary"
                                            onClick={() => this.setState(_.set({ ...this.state }, "showContent", 1))}
                                            iconProps={clsx(classes.textColor, "text-18")}
                                            icon={"notes"}
                                        />
                                        {!_.isNull(form.idagendamento) &&
                                            <XAPPButton
                                                tooltip={{ "title": "Tarefas", "placement": "top" }}
                                                type="icon"
                                                className={clsx("p-8", this.state.showContent === 2 && classes.selected)}
                                                variant="contained"
                                                color="textSecondary"
                                                onClick={() => this.setState(_.set({ ...this.state }, "showContent", 2))}
                                                iconProps={clsx(classes.textColor, "text-18")}
                                                icon={"checklist_add"}
                                            />
                                        }
                                    </div>
                                    {this.state.showContent === 0 &&
                                        <React.Fragment>
                                            <div className={clsx("flex w-full items-center flex-wrap sm:flex-no-wrap px-12")} >
                                                <div className={clsx(classes.formGroup, "flex flex-row rounded-6 mt-16", !_.isNull(EmpresaLocais) ? "w-1/2 sm:mr-8" : " w-full")}>
                                                    <Typography className={classes.formGroupTitle} color="textSecondary">{"Tags"}</Typography>
                                                    <FormControl component="span" className={classes.formControl} key={"Tags_Paper"} name={"Tags_Paper"} style={{ minHeight: 54 }}>
                                                        <TagFormulario
                                                            key={"TagsAgendamento"}
                                                            tags={!_.isUndefined(TagsAgendamento) && !_.isNull(TagsAgendamento) ? TagsAgendamento : []}
                                                            selected={form.tags}
                                                            target="tags"
                                                            onChange={handleChange}
                                                            xappRouteParams={xappRouteParams}
                                                            refreshTags={callback}
                                                            tipo={"agendamento"}
                                                        />
                                                    </FormControl>
                                                </div>
                                                {!_.isUndefined(EmpresaLocais) && !_.isNull(EmpresaLocais) &&
                                                    <TextField
                                                        className="mt-16 w-full sm:w-1/2"
                                                        label="Local"
                                                        id="idpessoaformulariolocal"
                                                        name="idpessoaformulariolocal"
                                                        value={form.idpessoaformulariolocal}
                                                        onChange={handleChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        placeholder="Selecione"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        select
                                                    >
                                                        <MenuItem key={"Local_Dafault"} value={null}>{""}</MenuItem>
                                                        {EmpresaLocais.map(item => (
                                                            <MenuItem key={"Local_" + item.idpessoaformulario} value={item.idpessoaformulario}>{item.nome}</MenuItem>
                                                        ))}
                                                    </TextField>
                                                }
                                            </div>
                                            <div className={clsx("flex w-full flex-wrap sm:flex-no-wrap items-start px-12")} >
                                                <FuseChipSelect
                                                    className="mt-16 w-full sm:w-1/2 sm:mr-8"
                                                    variant="fixed"
                                                    value={form.responsaveisLookup !== null ? form.responsaveisLookup : []}
                                                    onChange={handleResponsaveis}
                                                    placeholder=""
                                                    isMulti
                                                    isDisabled={!_.isNull(form.idagendamento)}
                                                    isClearable={!_.isNull(form.idagendamento)}
                                                    options={getResponsaveis()}
                                                    noOptionsMessage={() => "Sem resultados"}
                                                    classes={{
                                                        valueContainer: "pl-8"
                                                    }}
                                                    textFieldProps={{
                                                        className: "flex-no-wrap ",
                                                        label: `${this.getDicionario("profissional", "profissional")} *`,
                                                        InputLabelProps: {
                                                            shrink: true
                                                        },
                                                        classes: { root: classes.select },
                                                        variant: "outlined"
                                                    }}
                                                />
                                                <EmpresaClienteApp
                                                    className="mt-16 w-full sm:w-1/2"
                                                    xappRouteParams={xappRouteParams}
                                                    selected={form.clientesLookup !== null ? form.clientesLookup : []}
                                                    label={this.getDicionario("cliente", "cliente")}
                                                    id={"LookupNovoAgendamentoCliente"}
                                                    onChange={handleLookupClientes}
                                                    callback={() => get(form.idagendamento, xappRouteParams)}
                                                    //required={true}
                                                    isLookup={true}
                                                    multiSelect={false}
                                                    readOnly={!_.isNull(form.idagendamento)}
                                                />
                                            </div>
                                            <div className={clsx("flex w-full px-12")} >
                                                <TextField
                                                    className="mt-16 w-full"
                                                    label="Observações"
                                                    id="preatendimento.observacao"
                                                    name="preatendimento.observacao"
                                                    value={form.preatendimento.observacao}
                                                    onChange={handleChange}
                                                    variant='outlined'
                                                    fullWidth
                                                    multiline
                                                    rows={4}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                        </React.Fragment>
                                    }
                                    {this.state.showContent === 1 &&
                                        <div className={"flex w-full"}>
                                            <Anotacao
                                                anotacoes={form.anotacoes}
                                                handleChangeAnotacoes={handleChangeAnotacoes}
                                            />
                                        </div>
                                    }
                                    {this.state.showContent === 2 && !_.isNull(form.idagendamento) &&
                                        <div className={"flex w-full"}>
                                            <EmpresaTarefaApp
                                                xappRouteParams={xappRouteParams}
                                                idparent={form.idagendamento}
                                                tipo={1}
                                            />
                                        </div>
                                    }
                                </Paper>
                            </div>
                            {this.showSidebar() &&
                                <div className='flex flex-col w-full'>
                                    {!_.isNull(form.responsaveis) && form.responsaveis.length > 0 &&
                                        <div className="flex flex-col justify-start">
                                            <Paper id="PaperHorario" className="w-full lg:mx-8 my-8">
                                                <div className={clsx(classes.toolbar, "w-full flex flex-row items-start justify-start items-center min-h-36")}>
                                                    <Typography className="ml-8" color="action">Horários disponíveis</Typography>
                                                    <div className="flex-1" />
                                                </div>
                                                <div id="ContentDivHorario" className={clsx("block p-12 w-full")}>
                                                    <DataHora
                                                        handleChange={handleChange}
                                                        handleChangeHorarios={handleChangeHorarios}
                                                        checkHorarioDisponivel={checkHorarioDisponivel}
                                                        handleChangeData={handleChangeData}
                                                        form={form}
                                                        xappRouteParams={xappRouteParams}
                                                        HorarioAgendado={HorarioAgendado}
                                                        get={get}
                                                        fullscreen={this.state.fullscreen}
                                                        handleResponsaveis={handleResponsaveis}
                                                        readOnly={!_.isNull(form.idagendamento)}
                                                        user={user}
                                                    />
                                                </div>
                                            </Paper>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </ React.Fragment>
                }
                {
                    form.tabValue === 1 &&
                    <React.Fragment>
                        {!_.isUndefined(form.clientesLookup) && !_.isNull(form.clientesLookup) && form.clientesLookup.length > 0 &&
                            <div className={"w-full px-16"} >
                                {form.clientesLookup.map((item, x) => (
                                    <Contato
                                        key={x}
                                        data={item}
                                        xappRouteParams={xappRouteParams}
                                        agendamento={form}
                                        save={save}
                                        get={get}
                                        STATUS={STATUS}
                                        saveAgendamentoPessoa={saveAgendamentoPessoa}
                                        TagsPessoa={TagsPessoa}
                                        handleChange={handleChange}
                                    />
                                ))}
                            </div>
                        }
                    </React.Fragment>
                }
                {
                    form.tabValue === 2 &&
                    <React.Fragment>
                        {!_.isUndefined(form.preatendimento.pedido) && !_.isNull(form.preatendimento.pedido) && form.preatendimento.pedido.length > 0 &&
                            <div className={"w-full px-16"} >
                                {form.preatendimento.pedido.map((item, x) => (
                                    <Produto
                                        key={x}
                                        data={item}
                                        xappRouteParams={xappRouteParams}
                                    />
                                ))}
                            </div>
                        }
                    </React.Fragment>
                }
                {
                    form.tabValue === 3 &&
                    <React.Fragment>
                        {!_.isUndefined(form.responsaveisLookup) && !_.isNull(form.responsaveisLookup) && form.responsaveisLookup.length > 0 &&
                            <div className={"w-full px-16"} >
                                {form.responsaveisLookup.map((item, x) => (
                                    <Responsavel
                                        key={x}
                                        data={item}
                                        xappRouteParams={xappRouteParams}
                                    />
                                ))}
                            </div>
                        }
                    </React.Fragment>
                }
            </React.Fragment >
        );
    }
}


export default withStyles(styles, { withTheme: true })(Bloqueio);
